import { requests } from '../apiAgent';

interface SaveWorkshiftCostCenterBody {
    startDate: string;
    endDate: string;
    costCenterId: number;
    employeeIds: (string | number)[];
}

interface DisassociateWorkshiftCostCenterBody {
    workshiftSchedulingsCostCentersIds: number[];
}

interface CostCenterSchedulesRequest {
    startDate: Date;
    endDate: Date;
    employees: CostCenterByEmployee[];
}

interface CostCenterByEmployee {
    employeeId: number;
    isBulkAssignment: boolean;
    costCenters: SchedulingCostCenterRequest[];
}

interface SchedulingCostCenterRequest {
    schedulingCostCenterId: number;
    costCenterId: number;
    costCenterName: string;
    date: Date;
    startTime: string;
    endTime: string;
    workshiftSchedulingId: number;
}

export const WorkshiftsSchedulingCostCenterAPI = {
    saveWorkshiftCostCenter: (body: SaveWorkshiftCostCenterBody) => {
        return requests
            .post('/jerusalem/api/v2.0.0/workshift-scheduling-cost-centers', body)
            .then((res: any) => res);
    },
    disassociateWorkshiftCostCenter: (body: DisassociateWorkshiftCostCenterBody) => {
        return requests
            .deleteWithBody(
                '/jerusalem/api/v2.0.0/workshift-scheduling-cost-centers/disassociate',
                body
            )
            .then((res: any) => res);
    },
    associateByHourRanges: (body: CostCenterSchedulesRequest) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-scheduling-cost-centers/associate-by-hour-ranges',
                body
            )
            .then((res: any) => res);
    },
};
